var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Waitlist = YouLi.Trip.Waitlist ? YouLi.Trip.Waitlist : {};

(function (YouLi) {
    (function (Trip) {
        (function (Waitlist) {

            const config = {
                modalId: '#JoinWaitlistModal',
                modalContentId: '.modal-content',
                formId: '#JoinWaitlistForm',
                submitButtonId: '#SubmitWaitlistForm',
                errorContainerId: '.waitlist-error',
                joinWaitlistUrl: '/Trip/JoinWaitlist',
                changeToWaitlistUrl: '/Trip/ChangeToWaitlist'
            };

            const initialiseValidator = function () {
                $.validator.unobtrusive.parse($(config.formId));
                YouLi.Validation.Init(config.formId);
            };

            const loadJoinWaitlistModal = function (tripId) {
                const params = {
                    tripId: tripId
                };

                YouLi.Common.Get({
                    url: config.joinWaitlistUrl,
                    params: params
                }).then(function (response) {
                    const $modal = $(config.modalId);
                    $modal.find(config.modalContentId).html(response);

                    initialiseValidator();

                    initJoinWaitlistFormSubmission();

                    $modal.modal('show');
                });
            };

            // Add new user and join waitlist
            const initJoinWaitlistFormSubmission = function () {
                $(config.formId).off('submit').on('submit', function (e) {
                    e.preventDefault();
                    const $form = $(this);
                    const $errorContainer = $form.find(config.errorContainerId);
                    const $submitButton = $(config.submitButtonId);

                    // Reset error state
                    $errorContainer.hide().text('');

                    if ($form.valid()) {

                        YouLi.Common.UI.ShowButtonLoading($submitButton);

                        const formData = $form.serialize();

                        YouLi.Common.Post({
                            url: config.joinWaitlistUrl,
                            params: formData,
                            contentType: 'application/x-www-form-urlencoded',
                            errorCallback: YouLi.Trip.Waitlist.JoinWaitlistFormFailure
                        }).then(YouLi.Trip.Waitlist.JoinWaitlistFormSuccess);
                    }

                    return false;
                });
            };

            YouLi.Trip.Waitlist.JoinWaitlistFormSuccess = function (response) {
                if (response.success) {
                    window.location.href = response.redirectUrl;
                } else {
                    showErrors(response.errors);
                    YouLi.Common.UI.HideButtonLoading($(config.submitButtonId));
                }
            };

            YouLi.Trip.Waitlist.JoinWaitlistFormFailure = function (xhr) {
                YouLi.Common.UI.HideLoading();

                const errorMessage = 'An error occurred. Please try again.';

                if (xhr.responseJSON && xhr.responseJSON.errors) {
                    showErrors(xhr.responseJSON.errors);
                } else {
                    showErrors([errorMessage]);
                }

                YouLi.Common.UI.HideButtonLoading($(config.submitButtonId));
            };

            // Change existing invitee to waitlisted status
            const changeToWaitlist = function (tripId, inviteeId, $button) {

                YouLi.Common.UI.ShowButtonLoading($button);

                const data = {
                    tripId: tripId,
                    inviteeId: inviteeId
                };

                YouLi.Common.Post({
                    url: config.changeToWaitlistUrl,
                    params: data,
                    errorCallback: function (xhr) {
                        YouLi.Trip.Waitlist.ChangeToWaitlistFailure(xhr, $button);
                    }
                }).then(YouLi.Trip.Waitlist.ChangeToWaitlistSuccess);
            };

            YouLi.Trip.Waitlist.ChangeToWaitlistSuccess = function (response) {

                if (response.success) {
                    if (response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    } else {
                        location.reload();
                    }
                } else {
                    if (response.message)
                        YouLi.Common.UI.ShowStandardDialog(response.message);
                }
            };

            YouLi.Trip.Waitlist.ChangeToWaitlistFailure = function (xhr, $button) {
                YouLi.Common.UI.HideButtonLoading($button);

                let errorMessage = 'An error occurred. Please try again.';

                if (xhr.responseJSON && xhr.responseJSON.message)
                    errorMessage = xhr.responseJSON.message;

                YouLi.Common.UI.ShowStandardDialog(errorMessage);
            };

            const showErrors = function (errors) {
                const $form = $(config.formId);
                const $errorContainer = $form.find(config.errorContainerId);

                if (errors && errors.length > 0) {
                    $errorContainer.html(errors.join('<br>')).show();
                } else {
                    $errorContainer.text('An error occurred. Please try again.').show();
                }
            };

            YouLi.Trip.Waitlist.Init = function () {
                $(document)
                    .off('click', '[data-action="join-waitlist"]')
                    .on('click', '[data-action="join-waitlist"]', function (e) {
                    e.preventDefault();
                    const $button = $(this);
                    const tripId = $button.data('trip-id');
                    const inviteeId = $button.data('invitee-id'); // Will be undefined for anonymous users

                    // Check if invitee is already on Trip
                    if (inviteeId) {
                        // Users already on trip - change their status directly
                        changeToWaitlist(tripId, inviteeId, $button);
                    } else {
                        // Anonymous user - show the registration modal
                        loadJoinWaitlistModal(tripId);
                    }
                });

                $(document).on('hidden.bs.modal', config.modalId, function () {
                    $(this).find(config.modalContentId).empty();
                });
            };

            $(document).ready(function () {
                YouLi.Trip.Waitlist.Init();
            });

        }(YouLi.Trip.Waitlist ? YouLi.Trip.Waitlist : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));